import { SERPFlight } from "../types/serpResult";

export const orderDatesAsc = (dates: string[]): string[] => {
  return dates.sort((a, b) => {
    const parseDate = (date: any) => {
      const [year, month, day] = date.split("-").map(Number);
      return Date.UTC(year, month - 1, day); // Ajuste: meses no JS começam do zero!
    };

    return parseDate(a) - parseDate(b);
  });
};

export const convertDayOfWeekToText = (dayOfWeek: number): string => {
  switch (dayOfWeek) {
    case 0:
      return "domingo";
    case 1:
      return "segunda";
    case 2:
      return "terça";
    case 3:
      return "quarta";
    case 4:
      return "quinta";
    case 5:
      return "sexta";
    case 6:
      return "sábado";
    default:
      return "";
  }
};

export const convertDateToDDM = (date: Date): string => {
  const day = date?.getDate();
  const month = date?.getMonth() + 1;

  return `${day}/${month}`;
};

export const convertDateToDDMMAAAA = (date: Date): string => {
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear().toString();

  return `${day}/${month}/${year}`;
};

export const convertToHHMM = (date: Date): string => {
  const hours = date.getHours();
  const minutes = date.getMinutes();

  return `${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes}`;
};

export const convertDurationToText = (duration: number): string => {
  const hours = Math.floor(duration / 60);
  const remainingMinutes = duration % 60;

  return hours > 0
    ? `${hours}h ${remainingMinutes > 0 ? `${remainingMinutes}min` : ""}`
    : `${remainingMinutes} min`;
};

export const formatDateYYYYMMDD = (
  year: number,
  month: number,
  day: number,
): string =>
  `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;

export const formatDateDDMMYYYY = (date: Date): string => {
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Janeiro é 0
  const year = date.getFullYear().toString();

  return `${day}/${month}/${year}`;
};

export const calculateWaitingTime = (
  currentFlight: SERPFlight,
  nextFlight: SERPFlight,
) => {
  if (!currentFlight || !nextFlight) return null;

  const arrivalDateTime = new Date(currentFlight.arrivalDate);
  arrivalDateTime.setHours(
    currentFlight.arrivalTime.getHours(),
    currentFlight.arrivalTime.getMinutes(),
    0,
    0,
  );

  const departureDateTime = new Date(nextFlight.departureDate);
  departureDateTime.setHours(
    nextFlight.departureTime.getHours(),
    nextFlight.departureTime.getMinutes(),
    0,
    0,
  );

  const diffMs = departureDateTime.getTime() - arrivalDateTime.getTime();

  if (diffMs < 0) {
    console.error(
      "⚠️ Erro: O horário de partida do próximo voo é menor que o de chegada.",
    );
    return null;
  }

  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

  return `${diffHours}h ${diffMinutes}min`;
};

export const getCurrentTime = () => {
  const currentDate = new Date();
  const brasiliaTimeZone = "America/Sao_Paulo";

  currentDate.toLocaleString("en-US", { timeZone: brasiliaTimeZone });

  const hours = String(currentDate.getHours()).padStart(2, "0");
  const minutes = String(currentDate.getMinutes()).padStart(2, "0");
  const seconds = String(currentDate.getSeconds()).padStart(2, "0");

  const brasiliaTime = `${hours}:${minutes}:${seconds}`;

  return brasiliaTime;
};

export const transformDatesToGTM = (
  departureDatesList: string[],
  returnDatesList: string[],
): any => {
  const departureDates: any = {};
  const returnDates: any = {};

  departureDatesList.forEach((departureDate, index) => {
    const [yyyy, mm, dd] = departureDate.split("-");
    departureDates[`departure_yyyy_0${index + 1}`] = yyyy;
    departureDates[`departure_mm_0${index + 1}`] = mm;
    departureDates[`departure_dd_0${index + 1}`] = dd;
  });

  returnDatesList.forEach((returnDate, index) => {
    const [yyyy, mm, dd] = returnDate.split("-");
    returnDates[`return_yyyy_0${index + 1}`] = yyyy;
    returnDates[`return_mm_0${index + 1}`] = mm;
    returnDates[`return_dd_0${index + 1}`] = dd;
  });

  return { ...departureDates, ...returnDates };
};

export const calculateDateDifference = (
  departureDatesList: string[],
  returnDatesList: string[],
): number | null => {
  if (returnDatesList.length === 0) {
    return null;
  }

  const departureDates = departureDatesList.map((date) =>
    new Date(date).getTime(),
  );
  const returnDates = returnDatesList.map((date) => new Date(date).getTime());

  const minDepartureDate = Math.min(...departureDates);
  const maxReturnDate = Math.max(...returnDates);

  const differenceInMilliseconds = maxReturnDate - minDepartureDate;
  const differenceInDays = Math.floor(
    differenceInMilliseconds / (1000 * 60 * 60 * 24),
  );

  return differenceInDays + 1;
};
